import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "src/components/dialogue/radix-dialog";
import EditCustomerForm from "./edit-customer-form";
import { Customer } from "src/redux/types/_customer.type";

const EditCustomerDialog = ({
  customer,
  open,
  close,
}: {
  customer: Customer;
  open: boolean;
  close: () => void;
}) => {
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="bg-white min-w-5xl max-w-5xl">
        <DialogHeader>
          <DialogTitle className="text-center">
            Edit {customer.first_name} {customer.last_name}
          </DialogTitle>
        </DialogHeader>
        <EditCustomerForm customer={customer} close={close}/>
      </DialogContent>
    </Dialog>
  );
};

export default EditCustomerDialog;
